import {
  get,
  post,
  patch,
  del,
} from '@/utils/request';

const url = 'card-del-records';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function getCardUpdateRecordsByStudentId({ page, size, student_id }) {
  return get({
    url: `${url}/students/${student_id}`,
    data: { page, size },
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(id) {
  return post({
    url,
    data: { card_del_apply_id: id },
  });
}

export function storeAll() {
  return post({
    url: `${url}/all`,
  });
}

export function update(id, data) {
  return patch({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id, data) {
  return del({
    url: `${url}/${id}/`,
    data,
  });
}
